var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frag_contain"},[_c('span',{staticClass:"title_icon"}),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.sub_title)?_c('span',{staticClass:"sub_title"},[_vm._v(_vm._s(_vm.sub_title))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }